import { useState, useEffect, useCallback } from "react";
import DashboardGreeting from "../DashboardGreeting";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import LeaveInfo1 from "../../assets/images/leav-info-1.svg";
import LeaveInfo2 from "../../assets/images/leav-info-2.svg";
import SmileIcon1 from "../../assets/images/happy.svg";
import SmileIcon2 from "../../assets/images/happy2.svg";
import NeutralIcon from "../../assets/images/neutral.svg";
import SadFaceIcon from "../../assets/images/sad-face.svg";
import OnLeaveIcon from "../../assets/images/calendarDashboardTop.svg";
import CalendarIcon from "../../assets/images/calendarDashboardTop2.svg";
import OnLeaveProfile from "../../assets/images/onleaveProfile.svg";
import ArrowIcon from "../../assets/images/arrow-right-up.svg";
import NewLeaveReq from "../../assets/images/newLeaveReq.svg";
import ApprovedReq from "../../assets/images/approvedReq.svg";
import RejectedReq from "../../assets/images/rejectedReq.svg";
import PendingReq from "../../assets/images/pendingReq.svg";
import CloseIcon from "../../assets/images/close.svg";
import BirthdayCake from "../../assets/images/cake.svg";
import { useStateContext } from "../../contexts/ContextProvider";
import { Link } from "react-router-dom";
import User1 from "../../assets/images/user1.png";
import User2 from "../../assets/images/user2.png";
import moment from "moment";
import LeaveHistoryService from "../../services/leaveHistory.service";
import LogsService from "../../services/logs.service";
import DataTable from "react-data-table-component";
import EmpDashboardStats from "./EmpDashboardStats";
import DashboardService from "../../services/dashboard.service";

const EMPDashboard = ({ user }) => {
  const navHeading = "Welcome to Leave Management!";
  const leaveStatus = "applied";
  const lateMark = "no";

  const { windowHeight, setWindowHeight } = useStateContext();

  const [myLogs, setMyLogs] = useState([]);

  const [leaveRequest, setLeaveRequest] = useState({
    newRequest: "",
    appoved: "",
    pending: "",
    rejected: "",
    totalLeaveRequest: "",
  });

  const fetchLeaveReqCount = useCallback((payload) => {
    DashboardService.getRmTeamLeaveReqCount(payload)
      .then((resp) => {
        setLeaveRequest(resp.data);
      })
      .catch((e) => console.log(e));
  }, []);

  useEffect(() => {
    if (user.role === "2") {
      const payload = {
        empid: user && user.empid,
      };
      fetchLeaveReqCount(payload);
    }
  }, [fetchLeaveReqCount, user]);

  const fetchMyLogs = useCallback(() => {
    const date = new Date();

    const fromDate = new Date(date);
    fromDate.setDate(date.getDate() - 2);

    const month = moment(new Date(date)).format("M");
    const year = moment(new Date(date)).format("YYYY");

    const payload = {
      empid: user && user.employeeCodeInDevice,
      fromdate: fromDate,
      todate: date,
      month: month,
      year: year,
    };
    LogsService.getEmpMonthlyAttendenceLogs(payload)
      .then((resp) => {
        setMyLogs(resp.data);
      })
      .catch((e) => console.log(e));
  }, [user]);

  useEffect(() => {
    fetchMyLogs();
  }, [fetchMyLogs]);

  const events = [
    { date: "2025-02-11", color: "lop" },
    { date: "2025-02-15", color: "compoff" },
    { date: "2025-02-21", color: "earned" },
  ];

  // const currentDate = new Date();

  const getTileClassName = ({ date, view }) => {
    if (view === "month") {
      const event = events.find(
        (event) => new Date(event.date).toDateString() === date.toDateString(),
      );
      return event ? `event-${event.color}` : null;
    }
    return null;
  };

  const [data, setData] = useState([]);

  const fetchData = useCallback(() => {
    const payload = {
      emp_id: user.empid,
    };

    LeaveHistoryService.getLeaveRequest(payload)
      .then((response) => {
        if (response.data) {
          setData(response.data);
        }
      })
      .catch((e) => console.log(e));
  }, [user.empid]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const columns = [
    {
      name: "Leave Reason",
      selector: (row) => row.leaveReason,
      cell: (row) => (
        <>
          <span title={`${row.leaveReason}`}>{`${row.leaveReason}`}</span>
        </>
      ),
      sortable: true,
    },
    {
      name: "From",
      selector: (row) => row.fromDate,
      cell: (row) => (
        <>
          <span title={`${row.fromDate}`}>{`${moment(
            row.fromDate,
            "DD-MM-YYYY",
          ).format("D MMMM, YYYY")}`}</span>
        </>
      ),
      sortable: true,
    },
    {
      name: "To",
      selector: (row) => row.toDate,
      cell: (row) => (
        <>
          <span title={`${row.toDate}`}>{`${moment(
            row.toDate,
            "DD-MM-YYYY",
          ).format("D MMMM, YYYY")}`}</span>
        </>
      ),
      sortable: true,
    },
    {
      name: "Duration",
      selector: (row) => row.leavedays,
      cell: (row) => (
        <>
          <span title={`${row.leavedays}`}>{`${row.leavedays}`}</span>
        </>
      ),
      sortable: true,
    },
    {
      name: "DOR",
      selector: (row) => row.dor,
      cell: (row) => (
        <>
          <span title={`${row.dor}`}>{`${row.dor}`}</span>
        </>
      ),
      sortable: true,
    },
    {
      name: "RM Approval",
      selector: (row) => row.rmActionsts,
      cell: (row) => (
        <>
          <div
            className={`${
              row.rmActionsts === "0" ? "status pending" : "status approved"
            }`}
          >
            <span
              title={`${row.rmActionsts === "0" ? "Pending" : "Approved"}`}
            >{`${row.rmActionsts === "0" ? "Pending" : "Approved"}`}</span>
          </div>
        </>
      ),
      sortable: true,
      omit: user.role === "2",
    },
    {
      name: "HR Approval",
      selector: (row) => row.hrActionsts,
      cell: (row) => (
        <>
          <div
            className={`${
              row.hrActionsts === "0"
                ? "status pending"
                : row.hrActionsts === "2"
                  ? "status rejected"
                  : "status approved"
            }`}
          >
            <span
              title={`${
                row.hrActionsts === "0"
                  ? "Pending"
                  : row.hrActionsts === "2"
                    ? "Rejected"
                    : "Approved"
              }`}
            >{`${
              row.hrActionsts === "0"
                ? "Pending"
                : row.hrActionsts === "2"
                  ? "Rejected"
                  : "Approved"
            }`}</span>
          </div>
        </>
      ),
      sortable: true,
    },
    // {
    //   name: "Action",
    //   selector: (row) => row.actionStatusHR,
    //   cell: (row) => (
    //     <>
    //       <LeaveApplicationAction
    //         setEditLeaveModal={setEditLeaveModal}
    //         setDeleteLeaveModal={setDeleteLeaveModal}
    //         setSelectedData={setSelectedData}
    //         rowData={row}
    //         leaveCat={leaveCat}
    //       />
    //     </>
    //   ),
    //   sortable: true,
    // },
  ];

  const logscolumns = [
    {
      name: "Emp ID",
      selector: (row) => row.empid,
      cell: (row) => (
        <>
          <div className="emp-info">
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                className="bi bi-person-badge"
                viewBox="0 0 16 16"
              >
                <path d="M6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
                <path d="M4.5 0A2.5 2.5 0 0 0 2 2.5V14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2.5A2.5 2.5 0 0 0 11.5 0zM3 2.5A1.5 1.5 0 0 1 4.5 1h7A1.5 1.5 0 0 1 13 2.5v10.795a4.2 4.2 0 0 0-.776-.492C11.392 12.387 10.063 12 8 12s-3.392.387-4.224.803a4.2 4.2 0 0 0-.776.492z" />
              </svg>
            </span>
            <div className="flex-column">
              <span>{row.name}</span>
              <span className="code">ID: {row.empid}</span>
            </div>
          </div>
        </>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Date",
      selector: (row) => row.logdate,
      cell: (row) => (
        <>
          <span
            className="strong"
            title={`${row.logdate}`}
          >{`${row.logdate}`}</span>
        </>
      ),
      sortable: true,
      width: "125px",
    },
    {
      name: "In Time",
      selector: (row) => row.intime,
      cell: (row) => (
        <>
          <span title={`${row.intime}`}>{`${row.intime}`}</span>
        </>
      ),
      sortable: true,
    },
    {
      name: "Out Time",
      selector: (row) => row.outtime,
      cell: (row) => (
        <>
          <span title={`${row.outtime}`}>{`${row.outtime}`}</span>
        </>
      ),
      sortable: true,
    },
    {
      name: "Working Hours",
      selector: (row) => row.todaysWhourse,
      cell: (row) => (
        <>
          <span title={`${row.todaysWhourse}`}>{`${row.todaysWhourse}`}</span>
        </>
      ),
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      cell: (row) => (
        <>
          <div
            className={`${
              row.latemarkSts === "0" && row.status === "Present"
                ? "status present"
                : row.latemarkSts === "1"
                  ? "status latemark"
                  : row.status === "Absent" && row.holidaysts === "WorkDay"
                    ? "status absent"
                    : row.holidaysts === "Weekoff"
                      ? "status"
                      : "status"
            }`}
          >
            {row.latemarkSts === "0" && row.status === "Present" ? (
              <>
                <span title={row.status}>{row.status}</span>
              </>
            ) : row.latemarkSts === "1" ? (
              <span title="Late Mark">Late Mark</span>
            ) : row.holidaysts === "Weekoff" ? (
              <>
                <span title={row.holidaysts}>{row.holidaysts}</span>
              </>
            ) : (
              <>
                <span title={row.status}>{row.status}</span>
              </>
            )}
          </div>
        </>
      ),
      sortable: true,
    },
  ];

  useEffect(() => {
    let h = window.innerHeight;
    // console.log("height", h);
    setWindowHeight(h - 100);
  });

  return (
    <>
      <div className="dashboard-container">
        <DashboardGreeting navHeading={navHeading} user={user} />
        <div
          className="scroll"
          style={{ height: windowHeight, overflow: "scroll" }}
        >
          <div className="emp-stats">
            <EmpDashboardStats />
            {user.role === "2" && (
              <div className="monthly mb-5">
                <div className="d-flex mb-3">
                  <div className="heading arrow-flex">
                    <span>About recent leave requests</span>
                  </div>
                </div>
                <div className="list">
                  <div className="item">
                    <Link to={"/leaveRequest"} state={{ redirectIndex: 1 }}>
                      <div className="flex">
                        <div className="text">
                          <span>New Leave Requests</span>
                          <span className="count">
                            {leaveRequest.newRequest}
                          </span>
                        </div>
                        <div className="icon">
                          <img src={NewLeaveReq} alt="" />
                        </div>
                      </div>
                    </Link>
                  </div>
                  <div className="item">
                    <Link to={"/leaveRequest"} state={{ redirectIndex: 2 }}>
                      <div className="flex">
                        <div className="text">
                          <span>Approved</span>
                          <span className="count">{leaveRequest.appoved}</span>
                        </div>
                        <div className="icon">
                          <img src={ApprovedReq} alt="" />
                        </div>
                      </div>
                    </Link>
                  </div>
                  <div className="item">
                    <Link to={"/leaveRequest"} state={{ redirectIndex: 3 }}>
                      <div className="flex">
                        <div className="text">
                          <span>Rejected</span>
                          <span className="count">{leaveRequest.rejected}</span>
                        </div>
                        <div className="icon">
                          <img src={RejectedReq} alt="" />
                        </div>
                      </div>
                    </Link>
                  </div>
                  <div className="item">
                    <Link to={"/leaveRequest"} state={{ redirectIndex: 0 }}>
                      <div className="flex">
                        <div className="text">
                          <span>Total</span>
                          <span className="count">
                            {leaveRequest.totalLeaveRequest}
                          </span>
                        </div>
                        <div className="icon">
                          <span>
                            <svg
                              version="1.1"
                              baseProfile="basic"
                              id="Layer_1"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlnsXlink="http://www.w3.org/1999/xlink"
                              width="70"
                              height="70"
                              viewBox="0 0 71 71"
                              xmlSpace="preserve"
                            >
                              <path
                                fill="none"
                                stroke="#3B82F6"
                                strokeWidth="4.4"
                                strokeLinecap="round"
                                d="M59.2,41.4H8.9"
                              />
                              <path
                                fill="none"
                                stroke="#3B82F6"
                                strokeWidth="4.4"
                                strokeLinecap="round"
                                d="M32.5,53.2H8.9"
                              />
                              <line
                                fill="none"
                                stroke="#3B82F6"
                                strokeWidth="4.4"
                                strokeLinecap="round"
                                x1="8.9"
                                y1="17.8"
                                x2="39.9"
                                y2="17.8"
                              />
                              <line
                                fill="none"
                                stroke="#3B82F6"
                                strokeWidth="4.4"
                                strokeLinecap="round"
                                x1="59.2"
                                y1="17.8"
                                x2="52.5"
                                y2="17.8"
                              />
                              <line
                                fill="none"
                                stroke="#3B82F6"
                                strokeWidth="4.4"
                                strokeLinecap="round"
                                x1="59.2"
                                y1="29.6"
                                x2="28.1"
                                y2="29.6"
                              />
                              <line
                                fill="none"
                                stroke="#3B82F6"
                                strokeWidth="4.4"
                                strokeLinecap="round"
                                x1="8.9"
                                y1="29.6"
                                x2="15.5"
                                y2="29.6"
                              />
                              <line
                                fill="none"
                                stroke="#3B82F6"
                                strokeWidth="4.4"
                                strokeLinecap="round"
                                x1="46.9"
                                y1="53.2"
                                x2="59.2"
                                y2="53.2"
                              />
                            </svg>
                          </span>
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            )}

            <div className="row">
              <div className="col-xl-12 col-lg-12">
                <div className="leavestatus">
                  <div className="d-flex mb-3">
                    <div className="heading arrow-flex">
                      <span>Leave Status</span>
                      <Link to={"/leaveHistory"}>
                        <span className="arrow">
                          <img src={ArrowIcon} alt="" />
                        </span>
                      </Link>
                    </div>
                  </div>
                  <div className="">
                    <DataTable columns={columns} data={data} />
                  </div>
                </div>
              </div>
              <div className="col-xl-12 col-lg-12">
                <div className="leavestatus">
                  <div className="d-flex mb-3">
                    <div className="heading arrow-flex">
                      <span>Daily Log</span>
                      <Link to={"/dailyLogs"}>
                        <span className="arrow">
                          <img src={ArrowIcon} alt="" />
                        </span>
                      </Link>
                    </div>
                  </div>
                  <div className="">
                    <DataTable columns={logscolumns} data={myLogs} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="event-popup">
            <div className="close">
              <img src={CloseIcon} alt="" />
            </div>
            <div className="flex">
              <div className="date">
                <span>12 th February</span>
              </div>
              <div className="profiles">
                <div className="profile">
                  <span>
                    <img src={User1} alt="" />
                  </span>
                  <span>Darrell Steward</span>
                </div>
                <div className="profile">
                  <span>
                    <img src={User2} alt="" />
                  </span>
                  <span>Arlene McCoy</span>
                </div>
              </div>
              <div className="birthday-wish">
                <div className="wish-icon">
                  <span>
                    <img src={BirthdayCake} width={75} alt="" />
                  </span>
                </div>
                <div className="wish-content">
                  <span>Happy Birthday Darrell & Arlene</span>
                </div>
                <button>Send Wish</button>
                <p>
                  Wishing a very Happy Birthday! May this year brings you
                  success, happiness and good health.Your hard work and
                  positivity make the workplace better, and i hope you have a
                  fantastic day filled with joy and celebration!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default EMPDashboard;
